import { render, staticRenderFns } from "./SuccessRegistration.vue?vue&type=template&id=59e5f3c9&"
import script from "./SuccessRegistration.vue?vue&type=script&lang=js&"
export * from "./SuccessRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports